/* KAMIO HUB */
(function () {

  var IMG_BATTLE = 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/godtail-battle.png?v=1782695792';
  var IMG_NEON   = 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/ChatGPT_Image_Jun_6_2026_10_18_02_AM.png?v=1782695792';

  document.addEventListener('DOMContentLoaded', function () {
    injectHeroExtras();
    fixNavHierarchy();
    fixStudioNavLink();
    updateNewsletterCopy();
    addAboutToFooter();
    injectCharacterSpotlight();
    replaceStoryWithProductCarousel();
    forceHideSystemCursor();
    initCursorGlow();
    initScanlineOverlay();
    initParallax();
    initGameReskin();
    updateBrandLogo();
    fixProductCardImageFit();
    init3DHeroLogo();
  });

  /* Product card photos are roughly square, but cards are tall/portrait,
     so object-fit:cover was zooming in and cropping the top/bottom of
     every garment on collection grids. Switch to contain so the whole
     photo is always visible.

     Regression fix: the "VISUAL UPGRADE PASS" rim-light effect (in
     kamio-store.css) set .card__media{position:relative} so its glow
     pseudo-elements could anchor to it. Dawn's default card__media relies
     on position:absolute to inherit the ratio box's full size — switching
     it to relative broke that, and because .card__inner is display:flex
     with flex:0 1 auto (no grow), card__media collapsed to hug its own
     (now out-of-flow, non-contributing) content instead of filling the
     card. That's the "snipped/half-width card with dead space" bug.
     Restoring an explicit width:100% (position:relative is untouched, so
     the glow effect still works) fixes it without reverting the glow. */
  function fixProductCardImageFit() {
    var style = document.createElement('style');
    style.textContent = '.card__media img, .collection-list__item .card__media img, .product-card img{object-fit:contain!important}' +
      '.card__inner .card__media, .card__media{width:100%!important;flex:1 1 auto!important}';
    document.head.appendChild(style);
  }

  /* Turn the static hero crest logo (<a class="hero-logo"><img>...) into a
     spinning 3D logo using the secondary "claw" wordmark, per the preview
     approved in chat. Just the artwork itself spinning in 3D space — no
     plaque box, no gold bevel edges, no background fill, transparent PNG
     shown as-is. Front + back faces (back is the same art, and needs no
     extra mirroring: the back face carries its own baked-in rotateY(180deg),
     so once the plaque has spun 180deg and that face is what's actually
     facing the viewer, its *net* rotation is 360deg = identity — it renders
     exactly as authored, matching the front face. Adding a counter
     scaleX(-1) on top of that would flip it instead of "fixing" it, which
     is what produced the mismatched/backwards-looking back face.
     Respects prefers-reduced-motion by showing a static front face with
     no animation. Purely additive: we replace only the <a> tag's inner
     markup, not its position in the DOM, so surrounding hero layout/
     spacing is untouched. */
  function init3DHeroLogo() {
    var link = document.querySelector('.hero-logo');
    if (!link) return;
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var LOGO = 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/kamio-logo.png?v=1783472969';

    link.innerHTML =
      '<span class="kamio-3d-stage">' +
        '<span class="kamio-3d-plaque">' +
          '<span class="kamio-3d-face kamio-3d-front"></span>' +
          '<span class="kamio-3d-face kamio-3d-back"><span class="kamio-3d-back-inner"></span></span>' +
        '</span>' +
      '</span>';

    var style = document.createElement('style');
    style.textContent =
      /* The theme's own scroll-reveal observer fades .hero-logo in from
         opacity:0 keyed to its original <img>'s load event. Since we just
         replaced that <img> with 3D span markup, that trigger never fires
         and the logo can get stuck invisible. Force it visible regardless
         of the reveal system's state (hover lift transform is untouched). */
      '.hero-logo.reveal{opacity:1!important}' +
      '.kamio-3d-stage{display:block;width:320px;height:320px;perspective:1400px}' +
      '.kamio-3d-plaque{display:block;position:relative;width:100%;height:100%;transform-style:preserve-3d;' +
        (reduce ? '' : 'animation:kamio-3d-spin 7s linear infinite;') + '}' +
      '.kamio-3d-face{position:absolute;inset:0;backface-visibility:hidden;' +
        'background:url(' + LOGO + ') center/contain no-repeat}' +
      '.kamio-3d-front{transform:translateZ(1px)}' +
      '.kamio-3d-back{transform:rotateY(180deg) translateZ(1px)}' +
      '.kamio-3d-back-inner{display:block;width:100%;height:100%;' +
        'background:url(' + LOGO + ') center/contain no-repeat}' +
      '@keyframes kamio-3d-spin{from{transform:rotateY(0deg)}to{transform:rotateY(360deg)}}' +
      '@media(max-width:480px){.kamio-3d-stage{width:220px;height:220px}}';
    document.head.appendChild(style);
  }

  /* The real, always-visible site logo is hardcoded in the custom header
     markup as <a class="brand"><img class="logo-img" src="{{ 'kamio-logo.webp' | asset_url }}">
     — a theme asset, not a Shopify Files/settings_data value, and separate
     from Dawn's native (hidden) header logo setting. Point it at the
     "Studio Kamio" crest emblem the user wants used at the top, and give it
     a touch more room since the crest carries two lines of text plus
     artwork (the previous logo was a thin single-line wordmark). */
  function updateBrandLogo() {
    var logo = document.querySelector('.brand .logo-img');
    if (!logo) return;
    logo.src = 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/studio-kamio-hero-logo.png?v=1783465875';
    logo.srcset = '';
    logo.alt = 'Studio Kamio';
    logo.classList.add('kamio-crest-logo');
  }

  /* Tiger Run mini-game reskin: the game draws its own bright daytime-blue
     sky directly on <canvas id="tigerGame"> — we never touch the game's JS
     or sprite-rendering logic (sections/kamio-game-hub.liquid is untouched).
     We add a CSS class (filter defined in kamio-store.css) plus a
     pointer-events:none overlay div tinted to the site's gold/void palette,
     kept in sync with the canvas's own box via ResizeObserver so it tracks
     the canvas's responsive scaling without any per-frame JS. */
  function initGameReskin() {
    var canvas = document.getElementById('tigerGame');
    if (!canvas) return;
    var wrap = canvas.parentElement;
    if (!wrap) return;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

    canvas.classList.add('kamio-game-reskin');

    var overlay = document.getElementById('tigerGameOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'tigerGameOverlay';
      overlay.className = 'kamio-game-overlay';
      wrap.appendChild(overlay);
    }

    function sync() {
      overlay.style.left = canvas.offsetLeft + 'px';
      overlay.style.top = canvas.offsetTop + 'px';
      overlay.style.width = canvas.offsetWidth + 'px';
      overlay.style.height = canvas.offsetHeight + 'px';
    }
    sync();

    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(canvas);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  /* Visual-upgrade pass: cursor glow + targeting-lock, ambient scanline texture,
     and scroll parallax on the character-spotlight art. All additive/cosmetic —
     none of this touches existing markup, positioning logic, or layout. Every
     piece respects prefers-reduced-motion. */

  /* Give the existing gold reticle (.cursor.cur-ring, already positioned by the
     theme's own script) a soft ambient glow, plus a "targeting lock" pulse when
     hovering anything interactive. We never touch the element's position logic —
     only add a class the theme's script doesn't know about. */
  function initCursorGlow() {
    var finePointer = window.matchMedia('(pointer:fine)').matches;
    var prefersReduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (!finePointer) return;

    var style = document.createElement('style');
    style.textContent = '' +
      '.cursor.cur-ring svg{filter:drop-shadow(0 0 4px rgba(255,194,51,.75)) drop-shadow(0 0 10px rgba(255,194,51,.35))}' +
      (prefersReduce ? '' :
        '.cursor.cur-ring svg{transition:transform .35s cubic-bezier(.16,1,.3,1)}' +
        '.cursor.cur-ring.is-locked svg{transform:scale(1.35) rotate(45deg);filter:drop-shadow(0 0 6px rgba(255,194,51,.95)) drop-shadow(0 0 16px rgba(255,194,51,.55))}' +
        '.cursor.cur-ring.is-locked svg circle{stroke-dasharray:4 3;animation:kamio-lock-spin 2.4s linear infinite}' +
        '@keyframes kamio-lock-spin{to{stroke-dashoffset:-28}}'
      );
    document.head.appendChild(style);

    if (prefersReduce) return;

    var ring = document.querySelector('.cursor.cur-ring');
    if (!ring) return;

    var LOCK_SELECTOR = 'a, button, input, textarea, select, .pc-card, .kamio-collection-nav__link, [role="button"]';

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(LOCK_SELECTOR)) ring.classList.add('is-locked');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(LOCK_SELECTOR)) {
        var to = e.relatedTarget;
        if (!to || !to.closest || !to.closest(LOCK_SELECTOR)) ring.classList.remove('is-locked');
      }
    });
  }

  /* A near-invisible animated scanline texture over the whole page for ambient
     "screen" depth. Fixed, pointer-events:none, extremely low opacity — purely
     atmospheric, can't affect layout or interaction. */
  function initScanlineOverlay() {
    var prefersReduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    var layer = document.createElement('div');
    layer.id = 'kamio-scanline';
    document.body.appendChild(layer);

    var style = document.createElement('style');
    style.textContent = '' +
      '#kamio-scanline{position:fixed;inset:0;pointer-events:none;z-index:150;opacity:.035;mix-blend-mode:overlay;' +
      'background:repeating-linear-gradient(0deg,rgba(255,194,51,.5) 0px,rgba(255,194,51,.5) 1px,transparent 1px,transparent 3px)' +
      (prefersReduce ? '' : ';animation:kamio-scan-drift 9s linear infinite') + '}' +
      (prefersReduce ? '' : '@keyframes kamio-scan-drift{0%{background-position:0 0}100%{background-position:0 120px}}');
    document.head.appendChild(style);
  }

  /* Subtle scroll parallax on the character-spotlight art (the section this file
     builds in injectCharacterSpotlight). Background layers drift slightly slower
     than scroll for depth. Skipped entirely under reduced motion. */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var ticking = false;
    function update() {
      ticking = false;
      var gallery = document.getElementById('charGallery');
      if (!gallery) return;
      var rect = gallery.getBoundingClientRect();
      var viewportMid = window.innerHeight / 2;
      var offset = (rect.top + rect.height / 2 - viewportMid) * -0.06;
      offset = Math.max(-24, Math.min(24, offset));
      var imgs = gallery.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.transform = 'translateY(' + offset + 'px) scale(1.06)';
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* The custom reticle cursor should fully replace the system arrow on desktop.
     Some elements (links, inputs, buttons) were still showing the real OS
     cursor alongside the reticle; force cursor:none everywhere it applies. */
  function forceHideSystemCursor() {
    var finePointer = window.matchMedia('(pointer:fine)').matches;
    var prefersReduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (!finePointer || prefersReduce) return;
    var style = document.createElement('style');
    style.textContent = '#kamio-hub, #kamio-hub a, #kamio-hub button, #kamio-hub input, #kamio-hub textarea, #kamio-hub select, #kamio-hub label, #kamio-hub *{cursor:none!important}';
    document.head.appendChild(style);
  }

  /* Quick win: single primary CTA above the fold ("Read the Webtoon"),
     plus a concrete one-sentence Godtail premise instead of tone words only. */
  function injectHeroExtras() {
    var lede = document.querySelector('.hero p.lede');
    if (!lede) return;

    var premise = document.createElement('p');
    premise.className = 'lede premise reveal';
    premise.innerHTML = 'In <b>Godtail</b>: a virus is turning the people of New Rouge into monsters called the Embraced &mdash; and Violet, who never asked for the powers now surging through her, may be the only one left who can still fight back.';
    lede.after(premise);

    var ctas = document.createElement('div');
    ctas.className = 'hero-ctas reveal';
    ctas.innerHTML = '<a class="btn hero-cta-primary" href="https://www.webtoons.com/en/canvas/godtail/list?title_no=678889" target="_blank" rel="noopener">Read the Webtoon &#9658;</a><a class="btn hero-cta-secondary" href="/pages/godtail">Enter the World of Godtail</a>';
    premise.after(ctas);

    var style = document.createElement('style');
    style.textContent = '.hero p.lede.premise{margin-top:14px;color:var(--ink);border-left:2px solid var(--gold);padding-left:16px}.hero-ctas{display:flex;align-items:center;gap:16px;flex-wrap:wrap;margin-top:28px}.btn.hero-cta-primary{background:var(--gold);color:var(--void);border-color:var(--gold);font-weight:800;box-shadow:0 0 22px -4px var(--gold)}.btn.hero-cta-primary::before{background:var(--gold-soft)}.btn.hero-cta-primary:hover{color:var(--void)}.btn.hero-cta-secondary{opacity:.7;font-size:12px;padding:12px 20px;border-color:var(--dim);color:var(--dim)}.btn.hero-cta-secondary::before{background:var(--dim)}.btn.hero-cta-secondary:hover{opacity:1}';
    document.head.appendChild(style);
  }

  /* Quick win: make Webtoon the single primary nav CTA; subordinate All Games. */
  function fixNavHierarchy() {
    var nav = document.querySelector('nav.top');
    if (!nav) return;
    var webtoon = nav.querySelector('.nav-cta.webtoon');
    var allgames = nav.querySelector('.nav-cta.allgames');
    if (webtoon) webtoon.innerHTML = '&#9658; Read Webtoon';
    if (allgames) allgames.textContent = 'All Games';
    if (webtoon && allgames && webtoon.nextElementSibling !== allgames) {
      nav.insertBefore(webtoon, allgames);
    }
    var style = document.createElement('style');
    style.textContent = 'nav.top a.nav-cta.allgames{background:transparent!important;color:var(--gold)!important;border-color:var(--gold)!important;box-shadow:none!important;opacity:.82}nav.top a.nav-cta.allgames:hover{background:var(--gold)!important;color:var(--void)!important;opacity:1}nav.top a.nav-cta.webtoon{background:var(--gold)!important;color:var(--void)!important;border-color:var(--gold)!important;box-shadow:0 0 16px -4px var(--gold)!important;font-weight:800!important}nav.top a.nav-cta.webtoon:hover{background:var(--gold-soft)!important;box-shadow:0 0 22px -2px var(--gold)!important}';
    document.head.appendChild(style);
  }

  /* Quick win: incentivize the newsletter signup instead of just "no noise". */
  function updateNewsletterCopy() {
    var p = document.querySelector('.kfoot-news p');
    if (p) p.innerHTML = 'Be first in line for <b>new chapters, game drops, and merch releases</b> &mdash; before anyone else hears about them. No noise.';
  }

  /* Point the top nav "Studio" link at the About page. */
  function fixStudioNavLink() {
    var nav = document.querySelector('nav.top');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
    var studioLink = links.find(function (a) { return a.textContent.trim() === 'Studio'; });
    if (studioLink) studioLink.setAttribute('href', '/pages/about');
  }

  /* Move "About the Studio" out of the hero CTAs and into the footer, under Company. */
  function addAboutToFooter() {
    var cols = document.querySelectorAll('.kfoot-col');
    var companyCol = null;
    cols.forEach(function (col) {
      var label = col.querySelector('span');
      if (label && label.textContent.trim() === 'Company') companyCol = col;
    });
    if (!companyCol) return;
    var a = document.createElement('a');
    a.href = '/pages/about';
    a.textContent = 'About the Studio';
    companyCol.appendChild(a);
  }

  /* Replace the "Read The Story" webtoon banner with a real product carousel + Shop All Collections CTA. */
  function replaceStoryWithProductCarousel() {
    var section = document.getElementById('story');
    if (!section) return;
    var oldBanner = section.querySelector('a.reveal');
    if (!oldBanner) return;

    var tag = section.querySelector('.tag');
    if (tag) tag.textContent = '// Store · Collection';
    var h2 = section.querySelector('h2');
    if (h2) h2.textContent = 'Shop The Drop';
    var meta = section.querySelector('.meta');
    if (meta) meta.textContent = 'APPAREL · HEADWEAR · MERCH';

    var PRODUCTS = [
      { title: 'Skull Pill Athletic Long Shorts', price: '$44.49', url: '/products/skull-pill-unisex-athletic-long-shorts', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/all-over-print-unisex-athletic-long-shorts-white-front-698ba9b4527b2.jpg?v=1770760654' },
      { title: 'Patriotic Hannah Stickers', price: '$3.50', url: '/products/patriotic-hannah-bubble-free-stickers', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/kiss-cut-stickers-white-3x3-default-6a4172c5cc257.jpg?v=1782674131' },
      { title: 'Hare Unisex Hoodie', price: '$48.99', url: '/products/hare-unisex-hoodie', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/unisex-premium-pullover-hoodie-carbon-grey-front-6a4170ed6de78.jpg?v=1782673677' },
      { title: 'OG Kamio Men’s Windbreaker', price: '$52.99', url: '/products/og-kamio-men-s-windbreaker', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/all-over-print-mens-windbreaker-black-front-6a417049a37da.jpg?v=1782673516' },
      { title: 'Tome Tapered Stainless Steel Tumbler', price: '$32.00', url: '/products/tome-tapered-stainless-steel-tumbler', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/tapered-stainless-steel-tumbler-20-oz-white-20oz-front-6a416f58e0384.jpg?v=1782673261' },
      { title: '"Colours" Cuffed Beanie', price: '$22.99', url: '/products/colours-cuffed-beanie', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/cuffed-beanie-white-front-698baf261121f.jpg?v=1770764618' },
      { title: 'Trucker Cap', price: '$25.99', url: '/products/trucker-cap', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/retro-trucker-hat-black-front-6a416cfa0e460.jpg?v=1782672646' },
      { title: 'Cloud Athletic Long Shorts', price: '$44.49', url: '/products/cloud-athletic-long-shorts', img: 'https://cdn.shopify.com/s/files/1/0505/4722/8863/files/all-over-print-unisex-athletic-long-shorts-white-front-6a416c4dd8ca9.jpg?v=1782672485' }
    ];

    var wrap = document.createElement('div');
    wrap.className = 'product-carousel reveal';

    var track = document.createElement('div');
    track.className = 'pc-track';
    PRODUCTS.forEach(function (p) {
      var card = document.createElement('a');
      card.className = 'pc-card';
      card.href = p.url;
      card.innerHTML = '<span class="pc-thumb"><img src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async"></span><span class="pc-title">' + p.title + '</span><span class="pc-price">' + p.price + '</span>';
      track.appendChild(card);
    });
    wrap.appendChild(track);

    var arrows = document.createElement('div');
    arrows.className = 'pc-arrows';
    arrows.innerHTML = '<button class="pc-arrow pc-prev" type="button" aria-label="Previous products">&#8249;</button><button class="pc-arrow pc-next" type="button" aria-label="Next products">&#8250;</button>';
    wrap.appendChild(arrows);

    var cta = document.createElement('a');
    cta.className = 'btn pc-shopall';
    cta.href = '/collections';
    cta.innerHTML = '&#9658; Shop All Collections';

    oldBanner.replaceWith(wrap);
    wrap.after(cta);

    arrows.querySelector('.pc-prev').addEventListener('click', function () { track.scrollBy({ left: -324, behavior: 'smooth' }); });
    arrows.querySelector('.pc-next').addEventListener('click', function () { track.scrollBy({ left: 324, behavior: 'smooth' }); });

    var style = document.createElement('style');
    style.textContent = '.product-carousel{position:relative}.pc-track{display:flex;gap:18px;overflow-x:auto;scroll-snap-type:x mandatory;padding-bottom:10px;-webkit-overflow-scrolling:touch;scrollbar-width:none}.pc-track::-webkit-scrollbar{display:none}.pc-card{flex:0 0 220px;scroll-snap-align:start;border:1px solid var(--line);background:var(--panel);text-decoration:none;display:flex;flex-direction:column;overflow:hidden;transition:.25s}.pc-card:hover{transform:translateY(-4px);border-color:var(--gold);box-shadow:0 0 30px -10px var(--gold)}.pc-thumb{position:relative;display:block;aspect-ratio:1/1;background:radial-gradient(circle at 50% 40%,#1a1a1a,#0d0d0d);overflow:hidden}.pc-thumb img{width:100%;height:100%;object-fit:cover;transition:.4s}.pc-card:hover .pc-thumb img{transform:scale(1.06)}.pc-thumb::after{content:"";position:absolute;inset:0;pointer-events:none;background:radial-gradient(ellipse at center,transparent 45%,rgba(0,0,0,.55) 100%);transition:box-shadow .3s ease}.pc-card:hover .pc-thumb::after{box-shadow:inset 0 0 34px -2px rgba(255,194,51,.6)}.pc-title{font-family:"Orbitron",sans-serif;font-size:13px;color:var(--ink);padding:14px 14px 4px;line-height:1.3}.pc-price{font-family:"Space Mono",monospace;font-size:12px;color:var(--gold);padding:0 14px 14px}.pc-arrows{display:flex;gap:10px;justify-content:flex-end;margin-top:14px}.pc-arrow{width:42px;height:42px;border:1px solid var(--line);background:rgba(7,7,7,.6);color:var(--gold);font-size:22px;cursor:pointer;transition:.2s}.pc-arrow:hover{background:rgba(255,194,51,.16);border-color:var(--gold)}.pc-shopall{display:inline-flex;margin-top:22px}@media(max-width:640px){.pc-card{flex:0 0 160px}}';
    document.head.appendChild(style);
  }

  function injectCharacterSpotlight() {
    var hero = document.querySelector('main.hero');
    if (!hero) return;

    var style = document.createElement('style');
    style.textContent = '.char-spotlight{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center;padding:80px 5vw;background:#0a0a0a;border-top:1px solid rgba(255,194,51,.12)}.char-gallery{position:relative;border:1px solid rgba(255,255,255,.08);background:radial-gradient(ellipse 80% 70% at 50% 40%,#16181f,#0d0d0d);overflow:hidden;border-radius:2px;aspect-ratio:3/4;max-height:520px;cursor:pointer}.char-gallery img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:top center;transition:opacity .5s ease;will-change:opacity}.char-gallery img.char-img-1{opacity:1}.char-gallery img.char-img-2{opacity:0}@media(hover:hover){.char-gallery:hover img.char-img-1{opacity:0}.char-gallery:hover img.char-img-2{opacity:1}}.char-gallery.is-slide-2 img.char-img-1{opacity:0}.char-gallery.is-slide-2 img.char-img-2{opacity:1}.char-slide-hint{position:absolute;bottom:12px;right:12px;display:flex;gap:6px;z-index:2;pointer-events:none}.char-slide-dot{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.3);transition:background .4s}.char-slide-dot.active{background:#ffc233}.char-copy{padding:8px 0}.char-label{font-family:Space Mono,monospace;font-size:10px;letter-spacing:.3em;color:#ffc233;text-transform:uppercase;margin-bottom:16px}.char-name{font-family:Orbitron,sans-serif;font-weight:900;font-size:clamp(22px,4vw,40px);line-height:1.1;color:#f4f1e8;margin-bottom:12px}.char-divider{width:40px;height:2px;background:#ffc233;margin:16px 0}.char-desc{font-family:Chakra Petch,sans-serif;font-size:14px;line-height:1.7;color:#a8a69d;max-width:420px}.char-cta{display:inline-block;margin-top:28px;font-family:Space Mono,monospace;font-size:11px;letter-spacing:.2em;color:#ffc233;text-decoration:none;text-transform:uppercase;border-bottom:1px solid rgba(255,194,51,.4);padding-bottom:2px;transition:border-color .2s,color .2s}.char-cta:hover{color:#fff;border-color:#fff}.char-hover-tip{margin-top:20px;font-family:Space Mono,monospace;font-size:10px;letter-spacing:.15em;color:rgba(255,255,255,.25)}@media(max-width:720px){.char-spotlight{grid-template-columns:1fr;gap:32px}.char-gallery{max-height:420px}.char-hover-tip{display:none}}';
    document.head.appendChild(style);

    var sec = document.createElement('section');
    sec.id = 'characters';
    sec.className = 'char-spotlight reveal';
    sec.innerHTML = '<div class="char-gallery" id="charGallery"><img class="char-img-1" src="' + IMG_BATTLE + '" alt="Godtail battle scene" loading="lazy"><img class="char-img-2" src="' + IMG_NEON + '" alt="Violet and Hannah in New Rouge" loading="lazy"><div class="char-slide-hint"><span class="char-slide-dot active" id="dot1"></span><span class="char-slide-dot" id="dot2"></span></div></div><div class="char-copy"><p class="char-label">// Meet the Characters</p><h2 class="char-name">Violet &amp;<br>Hannah</h2><div class="char-divider"></div><p class="char-desc">Two warriors from opposite ends of the spectrum &mdash; one wielding electric lightning forged from discipline, the other carrying the weight of a world that broke before she could save it. Together they navigate New Rouge: a neon-soaked city that survived the end of everything.</p><a class="char-cta" href="https://www.webtoons.com/en/canvas/godtail/list?title_no=678889" target="_blank" rel="noopener">Read Godtail on WEBTOON &#8599;</a><p class="char-hover-tip">[ hover image to see their world ]</p></div>';
    hero.after(sec);

    startSlideshow(document.getElementById('charGallery'));
  }

  function startSlideshow(gallery) {
    if (!gallery) return;
    var noHover = window.matchMedia('(hover:none)');
    var dot1 = document.getElementById('dot1');
    var dot2 = document.getElementById('dot2');
    var slide2Active = false;
    var timer = null;

    function goSlide(toSecond) {
      slide2Active = toSecond;
      if (toSecond) {
        gallery.classList.add('is-slide-2');
        if (dot1) dot1.classList.remove('active');
        if (dot2) dot2.classList.add('active');
      } else {
        gallery.classList.remove('is-slide-2');
        if (dot1) dot1.classList.add('active');
        if (dot2) dot2.classList.remove('active');
      }
    }
    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () { goSlide(!slide2Active); }, 3000);
    }
    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function onPointerChange() {
      if (noHover.matches) { startTimer(); }
      else { stopTimer(); goSlide(false); }
    }
    gallery.addEventListener('click', function () {
      if (!noHover.matches) return;
      stopTimer(); goSlide(!slide2Active); startTimer();
    });
    onPointerChange();
    noHover.addEventListener('change', onPointerChange);
  }

})();
